module.exports = __webpack_public_path__ + "static/img/a-3.e72e132b.png";